<div class="customer-display-container">
  @if (allowSwitch()) {
    <button
      class="switch-button"
      type="button"
      [attr.aria-label]="'Navigation.Choose.Organisation' | translate"
      (click)="openSwitchDialog.emit()"
    >
      <svg-icon src="assets/images/icons/refresh.svg"></svg-icon>
    </button>
  }
  <span class="content">
    <span class="customer-name">{{ customerName() }}</span>
    <span class="customer-abbreviation">{{ customerAbbreviation() }}</span>
  </span>
</div>
